import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Amenagement } from 'src/app/shared/models/amenagement';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class AmenagementService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllAmenagement(): Observable<Amenagement[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.amenagementUrl}/all`,
			'getAllAmenagement'
		);
	}

	importAmenagement(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'amenagement.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.amenagementUrl}/import`,
			`importAmenagement`,
			formData
		);
	}

	getAmenagementById(id: number): Observable<Amenagement> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.amenagementUrl}/get/${id}`,
			'getAmenagementById'
		);
	}

	updateAmenagement(amenagement: Amenagement): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.amenagementUrl}/update/${amenagement.id}`,
			'updateAmenagement',
			amenagement
		);
	}

	addAmenagement(amenagement: Amenagement): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.amenagementUrl}/add`,
			'addAmenagement',
			amenagement
		);
	}

	deleteAmenagement(amenagementId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.amenagementUrl}/delete/${amenagementId}`,
			`deleteAmenagement`
		);
	}
}
